module.exports = __webpack_public_path__ + "static/fonts/MontserratMedium.f6210ef5.ttf";